export class NoAuthorization {
  _t = 'NoAuthorization';
}
